/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueMq from 'vue-mq';
import VueApollo from 'vue-apollo';
import VueRouter from 'vue-router';
import {FocusTrap} from 'focus-trap-vue';
import Toasted from 'vue-toasted';
import {BootstrapVue, OverlayPlugin} from 'bootstrap-vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import collect from 'collect.js';
import {inspect} from '@xstate/inspect';
import apolloClient from "./apollo-client";
import router from "./router";
import {XSTATE_DEBUG_ENABLED} from "./constants.js";
import {installServiceWorker} from "./pwa/index";

require('./fa-icons');
require('./bootstrap');

window.FL = {};
window.FL.log = {
    info: console.log.bind(console),
    error: console.error.bind(console),
    debug: JSON.parse(process.env.MIX_DEBUG_LOGGING || "false") === true
        ? console.log.bind(console)
        : function () {}
}

window.Vue = Vue;
window.collect = collect;

Vue.use(VueApollo);
Vue.use(VueRouter);

Vue.use(VueMq, {
    breakpoints: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: Infinity,
    }
});
Vue.use(OverlayPlugin);
Vue.use(BootstrapVue);
Vue.use(Toasted, {
    iconPack: 'custom-class',
    containerClass: 'text-left'
});

Vue.toasted.register('appInfo', (data) => {
    return data.message || 'Success';
}, {
    type: 'info',
    position: 'bottom-right',
    icon: {
        name: 'fa fa-info-circle fa-w-16 fa-fw mr-2'
    },
    duration: 4000
});

Vue.toasted.register('appSuccess', (data) => {
    return data.message || 'Success';
}, {
    type: 'success',
    position: 'bottom-right',
    icon: {
        name: 'fa fa-check fa-w-16 fa-fw mr-2'
    },
    duration: 4000
});

Vue.toasted.register('appError', (data) => {
    return data.message || 'Error';
}, {
    type: 'error',
    position: 'bottom-right',
    icon: {
        name: 'fa fa-check fa-w-16 fa-fw mr-2'
    },
    duration: 4000
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => {
    const camelCaseName = key.split('/').pop().split('.')[0];
    const kabobCaseName = camelCaseName
        .replace(/[\w]([A-Z])/g, function (m) {
            return m[0] + "-" + m[1];
        })
        .toLowerCase();
    return Vue.component(kabobCaseName, files(key).default);
});

Vue.component('fa-icon', FontAwesomeIcon);
Vue.component(VueQrcode.name, VueQrcode);
Vue.component('focus-trap', FocusTrap);

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});

if (XSTATE_DEBUG_ENABLED) {
    inspect({
        url: "https://statecharts.io/inspect",
        iframe: false
    });
}

/**
 * Create a fresh Vue application instance and attach it to the page.
 */
new Vue({
    el: '#app',
    apolloProvider,
    router
});

installServiceWorker();
